import {
  getBirthDateDescription,
  getBornRange,
  getActorDescription as getSharedDescription,
  getDiedRange,
  getName,
  getBirthPlace,
  getDeathPlace,
  getDeathDateDescription
} from "@thegetty-private/linked-data.js";
import { normalizeFieldToArray } from "@thegetty/linkedart.js";

/**
 * Gets the Birth Date for the person -- first looking at the LinguisticObject version, then falling back on the date range
 * @param {Object} object - the person
 *
 * @returns {String} the birth date as text
 */
export function getBirthDate(object) {
  let returnDate = getBirthDateDescription(object);
  if (returnDate == undefined) {
    let b_range = getBornRange(object);
    returnDate = b_range ? b_range["gte"] : undefined;
  }
  return returnDate;
}

/**
 * Gets the Description the person
 * @param {Object} object - the person
 *
 * @returns {String} the description
 */
export function getDescription(object) {
  let description = getSharedDescription(object);
  if (Array.isArray(description)) {
    return description[0];
  }
  return description;
}

/**
 * Gets the Death Date for the person -- first looking at the LinguisticObject version, then falling back on the date range
 * @param {Object} object - the person
 *
 * @returns {String} the death date as text
 */
export function getDeathDate(object) {
  let returnDate = getDeathDateDescription(object);
  if (returnDate == undefined) {
    let d_range = getDiedRange(object);
    returnDate = d_range ? d_range["lte"] : undefined;
  }
  return returnDate;
}

/**
 * Takes an elasticSearch object and transforms it into the cards
 *
 * @param {_object} object - The elasticsearch object
 *
 * @return {object} The card fields
 */
export function getCardFields(_object) {
  return {};
}

/**
 *  Gets all of the metadata fields for the Actor
 * @param {Object} object - the Actor object
 *
 * @returns {Object} an object with field names as keys and values as values
 */
export function getMetadataFields(object) {
  const birthPlace = getBirthPlace(object);
  const birthDate = getBirthDate(object);
  const deathPlace = getDeathPlace(object);
  const deathDate = getDeathDate(object);

  return { birthPlace, birthDate, deathPlace, deathDate };
}

/**
 * Gets the Page title (the name)
 * @param {Object} object  - the actor
 *
 * @returns {String}
 */
export function getPageTitle(object) {
  return getName(object);
}

/**
 * Gets the LCSH (Library of Congress) link from the exact_match
 * @param {Object} object  - the actor
 *
 * @returns {String}
 */
export function getLCSHLink(object) {
  let exactMatch = normalizeFieldToArray(object, "exact_match");
  let url = undefined;
  for (let match of exactMatch) {
    if (match != undefined && match.id.indexOf("id.loc.gov") > -1) {
      url = match.id;
    }
  }
  return url;
}
